<template>
    <!--begin lifestyle-coaching div -->
    <div id="lifestyle-coaching">
        <!-- begin featured-header section -->
        <section class="featured-header">
            <div class="featured-header-bg lazyload" :data-bg="`${staticAssetPath}/img/lifestyle-coaching/header-bg.png`"></div>
            <div class="featured-header-content">
                <div class="featured-tagline"><h1>Lifestyle Coaching</h1></div>
                <div class="featured-subtagline"><h2>Sharecare Lifestyle Coaching actively targets and engages individuals who are at risk for developing a condition. Using conversational questioning, collaborative goal setting, and varying contact frequency and modality, we connect the participant’s health behaviors with their stated core values and health goals.</h2></div>
            </div>
        </section>
        <!--end of featured-header section -->

        <!--begin meet section -->
        <section class="meet">
            <div class="row">
                <div class="content-container">
                    <div class="centered main-meet">Meet people where they are, not where someone else wants them to be. The program is personalized to the participant, designed to address the following areas that contribute to overall physical health and well-being: exercise, healthy eating, stress management, tobacco cessation and weight management.</div>
                    <div class="centered additional-meet">Additional wellbeing topics embedded within the program include:
                        <ul>
                            <li>Appointment &amp; medication adherence</li>
                            <li>Depression screening, management and referral (if necessary)</li>
                            <li>Education and management of health numbers and risk indicators</li>
                        </ul>
                    </div>
                    
                </div>
            </div>
        </section>
        <!-- end meet section -->

        <!--begin meet-list section -->
        <section class="meet-list">
            <div class="row">
                <div class="content-container">
                    <ul>
                        <li>NCQA Wellness and Health Promotion accredited</li>
                        <li>Sharecare's behavioral model empowers the coach to be both a supportive guide and wellness expert.</li>
                        <li>Our person-centered approach enables us to engage and activate members that traditional riskcentered programming might overlook due to a perceived lack of readiness or commitment.</li>
                    </ul>
                </div>
            </div>
        </section>
        <!-- end meet-list section -->

        <!-- begin personalized-support section -->
        <section class="personalized-support">
            <div class="row">
                <div class="content-wrapper">
                    <div class="content">
                        <H2FeaturedHeader featuredHeader="Personalized support for your health journey" />
                        <div class="callouts">
                            <div class="callout">
                                <div class="callout-number">13.5%</div>
                                <div class="callout-desc">Behavioral Risk Reducation<sup>*</sup></div>
                            </div>
                            <div class="callout">
                                <div class="callout-number">$11M</div>
                                <div class="callout-desc">In Savings<sup>*</sup></div>
                            </div>
                            <div class="callout">
                                <div class="callout-number">58%</div>
                                <div class="callout-desc">Of employees at a Fortune 500 company enrolled in our program reported weight or fat less</div>
                            </div>
                            <div class="callout">
                                <div class="callout-number">55%</div>
                                <div class="callout-desc">Of employees at a Fortune 500 company enrolled in our program reported increase in physical activity</div>
                            </div>
                        </div>
                    </div>
                    <div class="content-img">
                        <picture>
                            <source :data-srcset="`${staticAssetPath}/img/lifestyle-coaching/personalized-support.jp2`" type="image/jp2">
                            <source :data-srcset="`${staticAssetPath}/img/lifestyle-coaching/personalized-support.webp`" type="image/webp">
                            <source :data-srcset="`${staticAssetPath}/img/lifestyle-coaching/personalized-support.png`" type="image/png">
                            <img class="lazyload" :data-src="`${staticAssetPath}/img/lifestyle-coaching/personalized-support.png`" alt="Person holding mobile phone">
                        </picture>
                    </div>
                </div>
            </div>
        </section>
        <!-- end personalized-support section -->

        <!-- begin digital coaching section -->
        <section class="digital-coaching">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Digital Coaching" />
                <FeaturedSubHeader featuredContent="Participants are able to communicate with coaches via digital modalities as well as engage with digital programming and tools to support their experience. Setting healthy action steps and tracking progress through online tools allows the member to remain engaged with their coach in between coaching sessions." />
            </div>
        </section>
        <!-- end digital coaching section -->

        <!-- beginning of highly-skilled section -->
        <section class="highly-skilled">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Highly skilled, trained, empathetic coaches" />
                <FeaturedSubHeader featuredContent="This program teaches participants how to take healthy steps to change behavior with the support of a personal coach. By setting achievable health goals and encouraging the participants to take small action steps, they build confidence through success and more readily progress towards goal achievement." />
                <ul class="highly-skilled-list">
                    <li>Regular contact with a coach by telephone or through digital modalities</li>
                    <li>Self-directed online programming and tools such as trackers, challenges, educational resources and more</li>
                    <li>Realistic and achievable goals that build confidence</li>
                    <li>A collaborative, person-centric — not risk-centric — approach </li>
                </ul>
                <div class="bottom-content">To learn more about Sharecare's Lifestyle Behavior Coaching please contact <strong>hello@sharecare.com</strong></div>
            </div>
        </section>
        <!-- end of highly-skilled section -->

        <!-- beginning of contact-sharecare -->
        <section class="contact-sharecare">
            <div class="row">
                <H2FeaturedHeader featuredHeader="Contact Sharecare to learn more" />
                <div class="form-container">
                    <iframe class="lazyload" title="lifestyle-coaching-contact-form" :data-src="`${staticPageManagerPath}/form/lifestyle-coaching-contact-form`" width="100%" height="500" type="text/html" frameborder="0" allowTransparency="true" scrolling="no" style="border: 0"></iframe>
                </div>
            </div>
        </section>
        <!-- end of contact-sharecare -->
    </div>
</template>

<script>
import '../../assets/styles/page-templates/lifestyle-coaching.scss';
import LifestyleCoaching from "../../assets/js/lifestyle-coaching";
import H2FeaturedHeader from "../../components/H2FeaturedHeader.vue";
import FeaturedSubHeader from "../../components/FeaturedSubHeader.vue";
//import StandardCallout from "../../components/StandardCallout.vue";
//import StandardListItemCallout from "../../components/StandardListItemCallout.vue";
import 'lazysizes';

setTimeout(function() {
new LifestyleCoaching(process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL);
},100)


export default {
     components: {
      H2FeaturedHeader,
      FeaturedSubHeader,
      //StandardListItemCallout,
      //StandardCallout,
    },
      data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
          staticPageManagerPath: process.env.VUE_APP_STATIC_PAGE_MANAGER_URL,
        }
      }
    }
</script>